import { render, staticRenderFns } from "./SpecificExtraWorkRequestListMobItem.vue?vue&type=template&id=2521aa46&scoped=true&"
import script from "./SpecificExtraWorkRequestListMobItem.vue?vue&type=script&lang=js&"
export * from "./SpecificExtraWorkRequestListMobItem.vue?vue&type=script&lang=js&"
import style0 from "./SpecificExtraWorkRequestListMobItem.vue?vue&type=style&index=0&id=2521aa46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2521aa46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCheckbox,VCol,VExpandTransition,VIcon,VRow})
